module.exports = __webpack_public_path__ + "static/CRM-w-chmurze-Jaki-CRM-wybrac-3d20897fb201f6ac4e144a27dac49a44.png";